// A deploy replaces the chunk set. A tab still running the previous deploy then
// asks for a chunk that no longer exists, and the error boundary catches a
// ChunkLoadError. reset() re-renders against the same missing chunk, so the
// only cure is a full reload — done at most once per session, so a chunk that
// is genuinely broken still ends on the fallback instead of a reload loop.

const CHUNK_FEL = /ChunkLoadError|Failed to load chunk|Loading chunk [\w-]+ failed/i;
const NYCKEL = "vektr-chunk-omladdad";

type Lagring = Pick<Storage, "getItem" | "setItem">;

/**
 * True when the page should reload itself for this error. Marks the session
 * before answering yes. Unreadable storage (private mode, blocked site data)
 * answers no: without the mark there is no guard against a loop.
 */
export function skaLaddaOmVidChunkFel(error: { name?: string; message?: string }, lagring: Lagring | null): boolean {
  if (!CHUNK_FEL.test(`${error.name ?? ""} ${error.message ?? ""}`)) return false;
  if (!lagring) return false;
  try {
    if (lagring.getItem(NYCKEL)) return false;
    lagring.setItem(NYCKEL, "1");
    return true;
  } catch {
    return false;
  }
}
